import React from 'react'
import Paper from '@material-ui/core/Paper'
import Text from '@material-ui/core/Typography'

function DashboardSavings({savings}){
   return (
      <Paper style={{ padding: 20, marginTop:20, textAlign:'center'}} >
       	<Text style={{lineHeight:.8}} variant='caption' display='block' color='textSecondary'>
           	Savings
         </Text>
      </Paper>
   )
}
export default DashboardSavings
